import {
  Container,
  ContentImg,
  ContentLogin,
  Logo,
  ButtonLogin,
  ButtonPerson,
  ButtonSatellite,
} from "./style";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/images/logo-login.png";
import NavBar from "../../components/navbar/navbar";
import Footer from "../../components/footer/footer";
import { useAuth } from "../../context/AuthContext";
import { ToastContainer } from "react-toastify";
import { useEffect } from "react";

import googlePlay from "../../assets/images/googlePlay.png"
import appStore from "../../assets/images/appStore.png"

export default function Choice() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { login, logout } = useAuth();

  useEffect(() => {
    logout();
  }, []);

  const handleLogin = (personal: string) => {
    localStorage.setItem("userType", personal);
    if (personal === "buy") {
      navigate("/loginBuy");
    } else if (personal === "enginner") {
      navigate("/loginengineer");
    } else if (personal === "seller") {
      navigate("/loginSeller");
    } else {
      const initialValues = {
        email: "satelite@satelite.com",
        password: "satelite",
        user_type: "satelite",
      };

      login(initialValues);

      navigate("/homeBuy");
    }
  };

  return (
    <div className="min-h-[calc(100vh-25px)] flex flex-col items-center p-5 !bg-linear-[180deg,#9eec48_2%,#cdf0a7_10%,white_30%,white_90%]">
      <ContentImg>
        <Logo className="flex justify-center">
          <img className="w-[70%]" src={logo} alt="Ecolife"></img>
        </Logo>
      </ContentImg>
      <h1 className="!text-2xl text-[#356405] pt-2">
        "Floresta em Pé, Vida em Equilíbrio"
      </h1>
      <div className="flex items-center justify-evenly w-1/3 mt-20">
        <a className="contents cursor-pointer" target="_blank" href="https://play.google.com/store/apps/details?id=br.com.ecolifemeioambiente.app&pcampaignid=web_share"><img className="w-[30%]"  src={googlePlay}/></a>
        <a className="contents cursor-pointer" target="_blank" href="https://apps.apple.com/us/app/ecolife-meio-ambiente/id6711330997"><img className="w-[30%]" src={appStore}/></a>
      </div>
      <ContentLogin>
        <ButtonLogin
          className="!mt-35
          max-[769px]:flex
          max-[769px]:flex-col
          max-[769px]:items-center
          max-[769px]:justify-center
        "
        >
          <button
            className="flex flex-col items-center justify-center 
              !text-white !font-[poppins] 
              !bg-[#5c8014] 
                w-[24rem] h-[5rem] 
                rounded-[0.625rem] !text-[1.375rem]
                hover:scale-110 transition-all duration-300
                max-[425px]:w-[10rem] max-[425px]:h-[5rem] max-[425px]:text-[0.5rem]
                max-[590px]:min-[426px]:w-[13rem] max-[590px]:min-[426px]:h-[5rem] max-[590px]:min-[426px]:text-[0.7rem]
                max-[670px]:min-[591px]:w-[10rem] max-[670px]:min-[591px]:h-[5rem] max-[670px]:min-[591px]:text-[1rem]"
            onClick={() => handleLogin("seller")}
          >
            <p>{t("seller")}</p>
            {/* {t("comment-seller")} */}
          </button>
          <button
            className="flex flex-col items-center justify-center
              !text-[#5c8014] !font-[poppins]  
              w-[24rem] h-[5rem] 
              !border-4 !border-[#5c8014]
              rounded-[0.625rem] !text-[1.375rem]
              hover:scale-110 transition-all duration-300
              max-[425px]:w-[10rem] max-[425px]:h-[5rem] max-[425px]:text-[0.5rem]
              max-[590px]:min-[426px]:w-[13rem] max-[590px]:min-[426px]:h-[5rem] max-[590px]:min-[426px]:text-[0.7rem]
              max-[670px]:min-[591px]:w-[10rem] max-[670px]:min-[591px]:h-[5rem] max-[670px]:min-[591px]:text-[1rem]"
            onClick={() => handleLogin("buy")}
          >
            <p>{t("buyer")}</p>
            {/* {t("comment-buyer")} */}
          </button>
          <button
            className="flex flex-col items-center justify-center 
            !text-white !font-[poppins] 
            !bg-[#5c8014] 
              w-[24rem] h-[5rem] 
              rounded-[0.625rem] !text-[1.375rem]
              hover:scale-110 transition-all duration-300
              max-[425px]:w-[10rem] max-[425px]:h-[5rem] max-[425px]:text-[0.5rem]
              max-[590px]:min-[426px]:w-[13rem] max-[590px]:min-[426px]:h-[5rem] max-[590px]:min-[426px]:text-[0.7rem]
              max-[670px]:min-[591px]:w-[10rem] max-[670px]:min-[591px]:h-[5rem] max-[670px]:min-[591px]:text-[1rem]"
            onClick={() => handleLogin("enginner")}
          >
            <p>{t("engineer")}</p>
            {/* {t("comment-engineer")} */}
          </button>
        </ButtonLogin>
        <button
          className="flex flex-col items-center justify-center 
            !text-white !font-[poppins] 
            !bg-[#45B7FE] 
              w-[24rem] h-[5rem] 
              rounded-[0.625rem] !text-[1.375rem]
              hover:scale-110 transition-all duration-300
              max-[425px]:w-[10rem] max-[425px]:h-[5rem] max-[425px]:text-[0.5rem]
              max-[590px]:min-[426px]:w-[13rem] max-[590px]:min-[426px]:h-[5rem] max-[590px]:min-[426px]:text-[0.7rem]
              max-[670px]:min-[591px]:w-[10rem] max-[670px]:min-[591px]:h-[5rem] max-[670px]:min-[591px]:text-[1rem]"
          onClick={() => handleLogin("satelite")}
        >
          <p>{t("satelite_principal")}</p>
        </button>
      </ContentLogin>
      <ToastContainer />
    </div>
  );
}
